import Phaser from 'phaser';

export interface TutorialStepOpts {
  targetX: number;
  targetY: number;
  dialogText: string;
  dialogX?: number;  // default 400 (center of 800px canvas)
  dialogY?: number;  // default 80 (top-center)
}

/**
 * Renders a pulsing arrow pointing at targetX/Y plus a dialog box with text.
 * Returns the container so the caller can destroy it when advancing steps.
 * Depth is 200 so it always sits above game objects.
 */
export function showTutorialStep(
  scene: Phaser.Scene,
  opts: TutorialStepOpts,
): Phaser.GameObjects.Container {
  const container = scene.add.container(0, 0).setDepth(200);

  // Arrow: downward-pointing triangle above the target
  const arrow = scene.add.graphics();
  arrow.fillStyle(0xffd54f, 1);
  // Tip at (targetX, targetY - 20); base corners at (±15, targetY - 50)
  arrow.fillTriangle(
    opts.targetX,      opts.targetY - 20,
    opts.targetX - 15, opts.targetY - 50,
    opts.targetX + 15, opts.targetY - 50,
  );
  scene.tweens.add({
    targets: arrow,
    alpha: { from: 0.5, to: 1 },
    yoyo: true,
    repeat: -1,
    duration: 600,
  });
  container.add(arrow);

  // Dialog box
  const dx = opts.dialogX ?? 400;
  const dy = opts.dialogY ?? 80;
  const dialogBg = scene.add.rectangle(dx, dy, 600, 80, 0x000000, 0.8)
    .setStrokeStyle(2, 0xffd54f);
  const dialogText = scene.add.text(dx, dy, opts.dialogText, {
    fontSize: '20px',
    color: '#ffffff',
    fontFamily: 'sans-serif',
    align: 'center',
    wordWrap: { width: 580 },
  }).setOrigin(0.5);

  container.add([dialogBg, dialogText]);

  return container;
}
